import router from '..'

export default [{
  path: '/admin/institution/BigDataScreen',
  name: 'InstitutionBigDataScreen',
  component: () => import('@/views/institution/device/bigDataScreen'),
  meta: {
    title: '数据大屏',
    headType: 2,
    auth: true,
    routerType: 2
  }
}, {
  path: '/admin/institution/deviceList',
  name: 'InstitutionDeviceList',
  component: () => import('@/views/institution/device/deviceList'),
  meta: {
    title: '设备列表',
    headType: 2,
    auth: true,
    routerType: 2
  }
}, {
  path: '/admin/institution/deviceAlarm',
  name: 'InstitutionDeviceAlarm',
  component: () => import('@/views/institution/device/deviceAlarm'),
  meta: {
    title: '报警记录',
    headType: 2,
    auth: true,
    routerType: 2
  }
}, {
  path: '/admin/institution/screenConfig',
  name: 'InstitutionScreenConfig',
  component: () => import('@/views/institution/device/screenConfig'),
  meta: {
    title: '大屏设置',
    headType: 2,
    auth: true,
    routerType: 2
  }
}]



// WEBPACK FOOTER //
// ./src/router/institution/device.js